import { connect } from 'react-redux'
import { setUserRolesModalIsBasicMessage, setUserRolesModalIsOpen } from 'redux/actions'
import IncorrectUserRoleModal from 'components/IncorrectUserRoleModal'

const mapStateToProps = (state) => ({
  isOpen: state.modals.userRole.isOpen,
  isBasicMessage: state.modals.userRole.isBasicMessage
})

const mapDispatchToProps = dispatch => ({
  setOpen: isOpen => dispatch(setUserRolesModalIsOpen(isOpen)),
  setIsBasicMessage: isBasicMessage => dispatch(setUserRolesModalIsBasicMessage(isBasicMessage))
})

export default connect(mapStateToProps, mapDispatchToProps)(IncorrectUserRoleModal)
